module.exports = __webpack_public_path__ + "img/map_full.c44992b3.jpg";